/*
 * @Description: 入网mixins
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2021-03-18 10:02:56
 * @LastEditTime: 2021-05-27 15:12:08
 */
import moment from "moment";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "一年",
            onClick(picker) {
              const date = moment()
                .add(1, "years")
                .startOf("day")
                .valueOf();
              picker.$emit("pick", date);
            }
          },
          {
            text: "两年",
            onClick(picker) {
              const date = moment()
                .add(2, "years")
                .startOf("day")
                .valueOf();
              picker.$emit("pick", date);
            }
          },
          {
            text: "三年",
            onClick(picker) {
              const date = moment()
                .add(3, "years")
                .startOf("day")
                .valueOf();
              picker.$emit("pick", date);
            }
          }
        ],
        disabledDate(time) {
          let timeStamp = moment(time).valueOf();
          let nowTime = moment()
            .startOf("day")
            .valueOf();
          return timeStamp < nowTime;
        }
      }
    };
  }
};
